module.exports = __webpack_public_path__ + "img/SEGURIFY_comparador_2.279ff499.png";